// These values must always be kept in sync with those of the less folder
// src/themes/RIO/css/mapping/spacings-map.scss

export const spacings = ['0', '1', '2', '3', '4', '5', '10', '15', '20', '25', '50'];
